// ** Folder Icons Data

export const folderIcons = {
	folder: {
		viewBox: "0 0 512 512",
		variants: {
			solid: {
				"data-prefix": "fas",
				"data-icon": "folder",
				source: "https://fontawesome.com/icons/folder",
				license: "https://fontawesome.com/license",
				path: "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z",
			},
		},
	},
};
